import { Shield, ShieldOff, ShieldQuestion } from "lucide-react";

interface Props {
  defaultEnforce: boolean | undefined;
}

// Compact policy-status pill for the terminal toolbar. The shield icon + tone
// carry the meaning; the full sentence lives in the tooltip so the control
// stays tight in a dense toolbar.
export function PolicyChip({ defaultEnforce }: Props) {
  if (defaultEnforce === undefined) {
    return (
      <div role="status" className="policy-chip policy-chip--unknown" title="Loading policy state…">
        <ShieldQuestion size={13} aria-hidden="true" />
        <span>Policy</span>
      </div>
    );
  }
  if (defaultEnforce) {
    return (
      <div
        role="status"
        className="policy-chip policy-chip--enforced"
        title="Admin enforces policies on agents"
      >
        <Shield size={13} aria-hidden="true" />
        <span>Enforced</span>
      </div>
    );
  }
  return (
    <div
      role="status"
      className="policy-chip policy-chip--observe"
      title="Admin runs in observe-only mode"
    >
      <ShieldOff size={13} aria-hidden="true" />
      <span>Observe</span>
    </div>
  );
}
